import { BaseTCIAppFeatureService, ITCIAppFeature, ITCIAppFeatureService, TCI_APP_FEATURE_TYPE } from "@tci/common";
import { Injectable } from "@angular/core";

@Injectable()
export class NgAppFeatureToggleService extends BaseTCIAppFeatureService implements ITCIAppFeatureService {
    private static instance: NgAppFeatureToggleService;

    public static getInstance(): NgAppFeatureToggleService {
        if (!NgAppFeatureToggleService.instance) {
            NgAppFeatureToggleService.instance = new NgAppFeatureToggleService();
        }
        return NgAppFeatureToggleService.instance;
    }


    constructor() {
        super();
        /**
         * Add app feature toggles here
         */
        // Note: enable TCI_APP_FEATURE_TYPE.ENV_ALERT to true for testing only, see more in file ~/docs/tickets/alerts.md
        this.setAppFeature(TCI_APP_FEATURE_TYPE.ENV_ALERT, { enabled: false } as ITCIAppFeature);
        this.setAppFeature(TCI_APP_FEATURE_TYPE.APP_AUTO_SCALE, { enabled: false } as ITCIAppFeature);
        this.setAppFeature(TCI_APP_FEATURE_TYPE.APP_MONITORING, { enabled: true } as ITCIAppFeature);
        this.setAppFeature(TCI_APP_FEATURE_TYPE.APP_STATUS_FILTER, { enabled: true } as ITCIAppFeature);
    }


}
